module.exports = new __parcel__URL__("troops_mercenary_small.720458dc.png").toString();